/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { spendRulesActorAttributesList } from "../funcs/spendRulesActorAttributesList.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { ListActorAttributesResult } from "../models/components/listactorattributesresult.js";
import {
  ListSpendRuleActorAttributesRequest,
  ListSpendRuleActorAttributesSecurity,
} from "../models/operations/listspendruleactorattributes.js";
import { unwrapAsync } from "../types/fp.js";

export class ActorAttributes extends ClientSDK {
  /**
   * listActorAttributes spendRules
   *
   * @remarks
   * List the member attributes a rule target condition can be written against, with each attribute's value kind. Static reference data that powers the rule editor's attribute picker.
   */
  async list(
    request?: ListSpendRuleActorAttributesRequest | undefined,
    security?: ListSpendRuleActorAttributesSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListActorAttributesResult> {
    return unwrapAsync(spendRulesActorAttributesList(
      this,
      request,
      security,
      options,
    ));
  }
}
